export type NavigationInterceptor = (targetPath: string) => boolean;

export interface LayoutState {
    pageTitle: string | null;
    isSidebarHidden: boolean;
    isLaunchpadVisible: boolean;
    isHeaderInBlendMode: boolean;
    navigationInterceptor: NavigationInterceptor | null;
    activeBottomRightPopup: string | null;
}

export enum LayoutActionType {
    SET_PAGE_TITLE = 'SET_PAGE_TITLE',
    SET_SIDEBAR_HIDDEN = 'SET_SIDEBAR_HIDDEN',
    TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR',
    SET_LAUNCHPAD_VISIBLE = 'SET_LAUNCHPAD_VISIBLE',
    SET_HEADER_IN_BLEND_MODE = 'SET_HEADER_IN_BLEND_MODE',
    SET_NAVIGATION_INTERCEPTOR = 'SET_NAVIGATION_INTERCEPTOR',
    REGISTER_BOTTOM_RIGHT_POPUP = 'REGISTER_BOTTOM_RIGHT_POPUP',
    UNREGISTER_BOTTOM_RIGHT_POPUP = 'UNREGISTER_BOTTOM_RIGHT_POPUP',
}

interface LayoutActions {
    setPageTitle: (title: string) => void;
    setIsSidebarHidden: (value: boolean) => void;
    toggleSidebar: () => void;
    setIsLaunchpadVisible: (value: boolean) => void;
    setIsHeaderInBlendMode: (value: boolean) => void;
    setNavigationInterceptor: (interceptor: NavigationInterceptor | null) => void;
    registerBottomRightPopup: (id: string) => void;
    unregisterBottomRightPopup: (id: string) => void;
}

export type LayoutAction =
    | { type: LayoutActionType.SET_PAGE_TITLE; payload: string }
    | { type: LayoutActionType.SET_SIDEBAR_HIDDEN; payload: boolean }
    | { type: LayoutActionType.TOGGLE_SIDEBAR }
    | { type: LayoutActionType.SET_LAUNCHPAD_VISIBLE; payload: boolean }
    | { type: LayoutActionType.SET_HEADER_IN_BLEND_MODE; payload: boolean }
    | { type: LayoutActionType.SET_NAVIGATION_INTERCEPTOR; payload: NavigationInterceptor | null }
    | { type: LayoutActionType.REGISTER_BOTTOM_RIGHT_POPUP; payload: string }
    | { type: LayoutActionType.UNREGISTER_BOTTOM_RIGHT_POPUP; payload: string };

export interface LayoutContextProps extends LayoutState, LayoutActions {}
